/**
 * datetime format
 * number format
 * string format
 *
 */
import moment from 'moment'

export default {
    dateformat(value, format) {
        if (!value) {
            return
        }

        return moment(value).format(format)
    }
}